import Leftmenu from '../element/leftmenu';
import Databorder from '../element/header';
import React, {Component} from "react";
import { DatePicker,Popconfirm,Button,Menu, Dropdown, Space } from 'antd';
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import { Line } from '@antv/g2plot';
import Histogramecharts from "../element/histogramecharts";
import Pieecharts from "../element/pieecharts";
import Linecharts from "../element/lineecharts";
import Line1charts from "../element/line1echarts";
import Line2charts from "../element/line2echarts";
import Line3charts from "../element/line3echarts";
import Pagelist from "../element/pagelist";
import Dataheader from "../element/dataheader";
import Datamenu from "../element/datamenu";
import Factorymapcharts from "../element/factorymapcharts";
import Datapie from "../element/datapie";
import Datatitle from "../element/datatitle";
import moment from "moment";
import Datafunnel from "../element/datafunnel";
import Datalinebottom from "../element/datalinebottom";
import Datacategory from "../element/datacategory";
import Datatitlemonth from "../element/datatitlemonty";
import Dataring from "../element/dataring";
import Dataline from "../element/dataline";
import Databg from "../element/databg";
import Dataradar from "../element/dataradar";
import Dataproductionline from "../element/dataproductionline";

class DataProduction extends Component{

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const pid = params.get("area");
        this.state = {
            array: [{"id":23788,"shuliaochanliang":"128","shuinichanliang":"0","kuangfenchanliang":"24","shuliaoshuinibi":"0.00","shuliaodianhao":"31.0","shuliaodianhaochengben":"19.5","shuliaomeihao":"101.7","shuliaomeihaochengben":"107.0","wandunshuliaochaiyou":"0.00","wandunshuliaoyuanmei":"1734.38","shuininenghao":"0.0","shuinidianhao":"0.0","dunshuiniyongqi":"0.00","dunshuiniyongshui":"0.00","wandunshuinichaiyou":"0.00"},{"id":23786,"shuliaochanliang":"513","shuinichanliang":"0","kuangfenchanliang":"91","shuliaoshuinibi":"0.00","shuliaodianhao":"63.5","shuliaodianhaochengben":"40.0","shuliaomeihao":"99.2","shuliaomeihaochengben":"104.5","wandunshuliaochaiyou":"0.00","wandunshuliaoyuanmei":"1087.72","shuininenghao":"0.0","shuinidianhao":"0.0","dunshuiniyongqi":"0.00","dunshuiniyongshui":"0.00","wandunshuinichaiyou":"0.00"},{"id":23785,"shuliaochanliang":"507","shuinichanliang":"0","kuangfenchanliang":"85","shuliaoshuinibi":"0.00","shuliaodianhao":"62.0","shuliaodianhaochengben":"39.0","shuliaomeihao":"99.9","shuliaomeihaochengben":"105.3","wandunshuliaochaiyou":"0.00","wandunshuliaoyuanmei":"1378.70","shuininenghao":"0.0","shuinidianhao":"0.0","dunshuiniyongqi":"0.00","dunshuiniyongshui":"0.00","wandunshuinichaiyou":"0.00"},{"id":23784,"shuliaochanliang":"520","shuinichanliang":"0","kuangfenchanliang":"78","shuliaoshuinibi":"0.00","shuliaodianhao":"64.0","shuliaodianhaochengben":"38.3","shuliaomeihao":"100.7","shuliaomeihaochengben":"106.0","wandunshuliaochaiyou":"0.00","wandunshuliaoyuanmei":"1769.23","shuininenghao":"0.0","shuinidianhao":"0.0","dunshuiniyongqi":"0.00","dunshuiniyongshui":"0.00","wandunshuinichaiyou":"0.00"},{"id":23783,"shuliaochanliang":"525","shuinichanliang":"110","kuangfenchanliang":"38","shuliaoshuinibi":"4.79","shuliaodianhao":"62.3","shuliaodianhaochengben":"39.3","shuliaomeihao":"99.6","shuliaomeihaochengben":"105.0","wandunshuliaochaiyou":"0.00","wandunshuliaoyuanmei":"1729.52","shuininenghao":"188.4","shuinidianhao":"326.3","dunshuiniyongqi":"20.94","dunshuiniyongshui":"1.68","wandunshuinichaiyou":"0.00"},{"id":23782,"shuliaochanliang":"525","shuinichanliang":"81","kuangfenchanliang":"0","shuliaoshuinibi":"6.49","shuliaodianhao":"63.7","shuliaodianhaochengben":"51.2","shuliaomeihao":"100.6","shuliaomeihaochengben":"105.9","wandunshuliaochaiyou":"0.00","wandunshuliaoyuanmei":"1727.62","shuininenghao":"333.1","shuinidianhao":"442.5","dunshuiniyongqi":"26.46","dunshuiniyongshui":"2.25","wandunshuinichaiyou":"0.00"},{"id":23781,"shuliaochanliang":"523","shuinichanliang":"0","kuangfenchanliang":"0","shuliaoshuinibi":"0.00","shuliaodianhao":"53.7","shuliaodianhaochengben":"52.6","shuliaomeihao":"99.5","shuliaomeihaochengben":"104.8","wandunshuliaochaiyou":"0.00","wandunshuliaoyuanmei":"774.38","shuininenghao":"0.0","shuinidianhao":"0.0","dunshuiniyongqi":"0.00","dunshuiniyongshui":"0.00","wandunshuinichaiyou":"0.00"}],
            count: [{"id":57455,"shihuishiliaowei":"11.90","yousejinshuzhaliaowei":"0.00","shayanliaowei":"2.70"}],
            sum: [{"id":24197,"dunshuliaojingfadian":"30.19","dunshuliaozongfadian":"30.62","yurejingfadian":"15375.8","yurezongfadian":"15596.0"},{"id":24196,"dunshuliaojingfadian":"27.27","dunshuliaozongfadian":"27.72","yurejingfadian":"13735.1","yurezongfadian":"13964.0"},{"id":24195,"dunshuliaojingfadian":"23.48","dunshuliaozongfadian":"24.00","yurejingfadian":"11856.1","yurezongfadian":"12120.0"},{"id":24194,"dunshuliaojingfadian":"24.33","dunshuliaozongfadian":"24.79","yurejingfadian":"12483.9","yurezongfadian":"12716.0"},{"id":24192,"dunshuliaojingfadian":"23.28","dunshuliaozongfadian":"23.87","yurejingfadian":"11942.8","yurezongfadian":"12244.0"},{"id":24191,"dunshuliaojingfadian":"24.41","dunshuliaozongfadian":"24.97","yurejingfadian":"12387.2","yurezongfadian":"12670.0"},{"id":24190,"dunshuliaojingfadian":"25.84","dunshuliaozongfadian":"26.37","yurejingfadian":"13434.7","yurezongfadian":"13710.0"}],
            area: pid,
            list: [
                {
                    floor:"矿粉",
                    unit:"4742.3",
                    elevator:"010301043",
                    medium:"958004.49",
                    tag:"ZL60",
                    taboo:"35",
                },
                {
                    floor:"熟料",
                    unit:"13419.36",
                    elevator:"010301043",
                    medium:"958004.49",
                    tag:"ZL60",
                    taboo:"35",
                },
                {
                    floor:"石灰石粉",
                    unit:"13419.36",
                    elevator:"010301043",
                    medium:"2714.2",
                    tag:"ZL60",
                    taboo:"35",
                },
                {
                    floor:"复合超细粉",
                    unit:"2714.2",
                    elevator:"010301043",
                    medium:"4742.3",
                    tag:"ZL60",
                    taboo:"35",
                },
            ]
        };
    }

    componentDidMount() {
        fetch("http://pd.pokemonbye.com:8088/api/getpdconllect?code=%E5%B0%8F%E6%97%B6")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    this.setState({
                        isLoaded: true,
                        array: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("http://pd.pokemonbye.com:8088/api/getpdlevel")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    this.setState({
                        isLoaded: true,
                        count: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("http://pd.pokemonbye.com:8088/api/getpdpower?code=%E5%B0%8F%E6%97%B6")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    this.setState({
                        isLoaded: true,
                        sum: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
    render() {

        return (
            <div>
                <div className="mainmax">
                    <Dataheader/>
                    <div className="colorbg">
                        <Databg/>
                        <div className="heigh top10">
                            <div className="stockbg">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <i className="fa iconfont icon-tudui"></i>
                                <p>石灰石料位<br/>{this.state.count[0].shihuishiliaowei}(米)</p>
                                <div className="texture1"></div>
                            </div>
                            <div className="stockbg">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <i className="fa iconfont icon-kuangye"></i>
                                <p>有色金属料位<br/>{this.state.count[0].yousejinshuzhaliaowei}(米)</p>
                                <div className="texture1"></div>
                            </div>
                            <div className="stockbg">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <i className="fa iconfont icon-turangyanfen"></i>
                                <p>砂岩料位<br/>{this.state.count[0].shayanliaowei}(米)</p>
                                <div className="texture1"></div>
                            </div>
                            <div className="stockbghl">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <div className="title">
                                    <i className="fa iconfont icon-24gl-gear3"></i>
                                    <p>余热发电</p>
                                    <div className="rbgm"></div>
                                    <div className="rbgm"></div>
                                    <div className="rbg"></div>
                                </div>
                                <p>吨熟料小时发电量</p>
                                <p>{this.state.sum[0].dunshuliaozongfadian}(千瓦)</p>
                                <p>余热小时发电量</p>
                                <p>{this.state.sum[0].yurezongfadian}(千瓦)</p>
                                <div className="texture"></div>
                            </div>
                        </div>
                        <div className="heigh left20 top12">
                            <div className="borderh">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <div className="title">
                                    <p>烧成车间（熟料）</p>
                                    <div className="rbgm"></div>
                                    <div className="rbgm"></div>
                                    <div className="rbg"></div>
                                </div>
                                <div className="stockbgh left10 top">
                                    <p><br/><br/>综合电耗成本(元/吨)<br/><strong>{this.state.array[0].shuliaodianhaochengben}</strong><br/><br/>综合电耗(千瓦)<br/><strong>{this.state.array[0].shuliaodianhao}</strong></p>
                                </div>
                                <div className="stockbgh left35 top">
                                    <p><br/><br/>综合煤耗成本(元/吨)<br/><strong>{this.state.array[0].shuliaomeihaochengben}</strong><br/><br/>综合煤耗(吨)<br/><strong>{this.state.array[0].shuliaomeihao}</strong></p>
                                </div>
                                <div className="stockbgh left70 top">
                                    <p><br/>柴油消耗量(吨)<br/><strong>{this.state.array[0].wandunshuliaochaiyou}</strong><br/><br/>原煤消耗量(吨)<br/><strong>{this.state.array[0].wandunshuliaoyuanmei}</strong></p>
                                </div>
                                <div className="texturebottom"></div>
                            </div>
                            <p className="centertext">熟料水泥比<br/>{this.state.array[0].shuliaoshuinibi}</p>
                            <div className="borderhtop">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <div className="title">
                                    <p>制成车间(水泥)</p>
                                    <div className="rbgm"></div>
                                    <div className="rbgm"></div>
                                    <div className="rbg"></div>
                                </div>
                                <div className="stockbgh left10 top">
                                    <p><br/><br/>综合能耗成本(元/千瓦)<br/><strong>{this.state.array[0].shuininenghao}</strong><br/><br/>综合电耗(千瓦)<br/><strong>{this.state.array[0].shuinidianhao}</strong></p>
                                </div>
                                <div className="stockbgh left35 top">
                                    <p><br/><br/>用气量(吨)<br/><strong>{this.state.array[0].dunshuiniyongqi}</strong><br/><br/>用水量(吨)<br/><strong>{this.state.array[0].dunshuiniyongshui}</strong></p>
                                </div>
                                <div className="stockbgh left70 top">
                                    <p><br/><br/><br/>柴油消耗量(吨)<br/><strong>{this.state.array[0].wandunshuinichaiyou}</strong></p>
                                </div>
                                <div className="texturebottom"></div>
                            </div>
                        </div>
                        <div className="heigh left15 top10">
                        </div>
                        <div className="heigh right0 top10">
                            <div className="stockbghll left-10">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <div className="title">
                                    <p>产量曲线</p>
                                    <div className="rbgm"></div>
                                    <div className="rbgm"></div>
                                    <div className="rbg"></div>
                                </div>
                                <Dataproductionline />
                            </div>
                            <div className="stockbg top51">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <i className="fa iconfont icon-jinding"></i>
                                <p>熟料<br/>{this.state.array[0].shuliaochanliang}(吨/小时)</p>
                            </div>
                            <div className="stockbg top52">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <i className="fa iconfont icon-shuinixingye"></i>
                                <p>水泥<br/>{this.state.array[0].shuinichanliang}(吨/小时)</p>
                            </div>
                            <div className="stockbg top53">
                                <div className="lt"></div>
                                <div className="rt"></div>
                                <i className="fa iconfont icon-turangcanshu"></i>
                                <p>矿粉<br/>{this.state.array[0].kuangfenchanliang}(吨/小时)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DataProduction;
